// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vel-modal[data-v-9dc63c72] {\n  z-index: 100000000000000000 !important;\n}", ""]);
// Exports
module.exports = exports;
